import React, { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/Overlay';

import { useWindowSize } from '../../hooks/useWindowSize';

interface Props {
  tooltip?: string;
  children?: any;
  className?: string;
  tooltipPlacement?: Placement;
  maxWidth?: string;
  style?: any;
}

export function EllipsisWithTooltip(props: Props) {
  const windowSize = useWindowSize();
  const { tooltip, children, className, tooltipPlacement } = props;
  const [showTooltip, setShowTooltip] = useState(undefined);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setShowTooltip(isEllipsisActive());
  }, [windowSize]);

  const isEllipsisActive = () => {
    const e = elementRef.current;
    if (!e) {
      return false;
    }
    return e.offsetWidth < e.scrollWidth ? undefined : false;
    // Returning 'false' disables tooltip show.
    // Returning 'true' shows tooltip.
    // Returning 'undefined' enables onhover tooltip show.
  };

  return (
    <OverlayTrigger placement={tooltipPlacement || 'auto'} overlay={<Tooltip id="t">{tooltip || children}</Tooltip>} show={showTooltip}>
      <div
        className={`hdn-text--ellipsis ${className || ''}`}
        ref={elementRef}
        style={{ ...props.style, maxWidth: props.maxWidth }}>
        {children || tooltip}
      </div>
    </OverlayTrigger>
  );
}
